import api from 'services/api';

type FetchSearchType = {
  videoHashId: string;
  shotHashId: string;
  qTerm: string;
  type: string;
};

export const fetchSearchResults = async ({ videoHashId, shotHashId, qTerm, type }: FetchSearchType): Promise<any> => {
  const response = await api.get(`/api/videos/${videoHashId}/shots/${shotHashId}/search/?q=${qTerm}&type=${type}`);
  return response.data;
};
